import React from 'react';
import { steps } from '../../data/site';
import { SectionHeading } from '../ui/SectionHeading';
export function Steps() {
  return <section className="bg-cream-light" aria-labelledby="steps-heading" data-id="element-242" data-mp="1334zpxsa979h">
      <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-28" data-id="element-243" data-mp="paykqf0v96bm">
        <SectionHeading eyebrow="How it goes" title="Four steps, and you can stop after any of them." intro="Designed for someone with no energy to spare. One question at a time, nothing lost if you close the tab, and no step that shames you for skipping it." data-id="element-244" data-mp="tbhe4dieqkfx" />

        <ol className="mt-14" data-id="element-245" data-mp="180x0zieti5qc">
          {steps.map((step, index) => <li key={step.title} className="rule" data-id="element-246" data-mp="182rfadvl2zlg" data-mpi={index}>
              <div className="grid gap-4 py-8 md:grid-cols-[auto_0.9fr_1.5fr] md:gap-12" data-id="element-247" data-mp="1cyosibbjvpu0">
                <p className="font-serif text-2xl text-brick" aria-hidden="true" data-id="element-248" data-mp="3sqmens3sblhg">
                  {String(index + 1).padStart(2, '0')}
                </p>
                <h3 className="font-serif text-2xl leading-snug text-ink md:text-[1.75rem]" data-id="element-249" data-mp="1i8966wvkp1v">
                  {step.title}
                </h3>
                <p className="max-w-2xl leading-relaxed text-ink-soft" data-id="element-250" data-mp="2vq76ah6dw19m">{step.detail}</p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}